import React from "react";
import Courses from "../../Courses/Courses";
import "./Landingcourse.css"
const LandingCourse = () => {
  return (
    <>
      <div className="landing-course-wrapper overflow-hidden">
        <div className="row">
          <Courses showHeading={false}/>
        </div>
      </div>
    </>
  );
};

export default LandingCourse;
